import { render, staticRenderFns } from "./CorrespondenceCreate.vue?vue&type=template&id=51341425&"
import script from "./CorrespondenceCreate.vue?vue&type=script&lang=js&"
export * from "./CorrespondenceCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports